export const translations = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About Us',
      process: 'Process',
      testimonials: 'Testimonials',
      contact: 'Contact',
      topbar: 'Licensed Public Adjusters — Available 24/7',
      freeConsultation: 'Free Consultation',
      call: 'Call',
    },
    hero: {
      badge: 'Licensed Public Adjusters',
      title: 'ELITE',
      subtitle: 'Property Adjusters LLC',
      desc: 'Maximizing your insurance claim settlement. We fight for the compensation you deserve when disaster strikes your home or business.',
      cta1: 'Get a Free Consultation',
      cta2: 'Our Services',
      stats: {
        s1: 'Years of Experience',
        s2: 'Available 24/7',
        s3: 'Claims Handled',
        s4: 'Millions Recovered',
      },
    },
    services: {
      tag: 'Areas of Expertise',
      title: 'Types of Claims We Handle',
      desc: 'Insurance companies have their own adjusters looking out for their bottom line. You need an Elite adjuster looking out for yours.',
      items: [
        {
          title: 'Water Damage',
          desc: 'Pipe bursts, leaks, and plumbing failures can cause hidden structural damage and mold. We ensure all damage is accounted for.',
        },
        {
          title: 'Fire & Smoke Damage',
          desc: 'Beyond the visible burn, smoke and soot can ruin property. We meticulously document all primary and secondary fire damage.',
        },
        {
          title: 'Storm & Hurricane',
          desc: 'High winds and flying debris can devastate your property. We specialize in complex catastrophic storm claims.',
        },
        {
          title: 'Roof Claims',
          desc: 'Whether from hail, wind, or age-related failure exacerbated by weather, we fight for full roof replacements when justified.',
        },
        {
          title: 'Mold Damage',
          desc: 'Mold requires specialized remediation. We work with experts to prove the cause and secure funds for proper cleanup.',
        },
        {
          title: 'Flood Claims',
          desc: 'Navigating FEMA and private flood policies is complex. We handle the red tape to maximize your flood recovery.',
        },
      ],
    },
    why: {
      tag: 'Why Choose Elite',
      title: 'We Level the Playing Field',
      desc: 'When you file an insurance claim, the insurance company sends their own adjuster to protect their interests. At Elite Property Adjusters LLC, we work exclusively for <strong>you</strong>. Our goal is to ensure you receive the maximum settlement allowed under your policy.',
      benefits: [
        'No Upfront Fees - We only get paid when you do',
        'Licensed & Certified Professionals',
        'Maximize Your Claim Settlement',
        'We Handle All Insurance Communications',
        'Detailed Damage Documentation & Estimating',
        'Stress-Free Process for Property Owners',
      ],
      cta: 'Speak With An Expert Today',
      exp1: '5+',
      exp2: 'Years of\nExperience',
    },
    process: {
      tag: 'Our Process',
      title: 'How We Maximize Your Claim',
      step: 'Step',
      learnMore: 'Learn More',
      steps: [
        {
          title: 'Free Inspection',
          desc: 'We conduct a thorough, no-obligation inspection of your property to assess the full extent of the damage.',
        },
        {
          title: 'Document & File',
          desc: 'We meticulously document all damages, prepare professional estimates, and officially file your claim.',
        },
        {
          title: 'Negotiate',
          desc: "We meet with the insurance company's adjusters and negotiate aggressively on your behalf.",
        },
        {
          title: 'Get Paid',
          desc: 'We secure the maximum settlement possible so you can properly restore your property.',
        },
      ],
    },
    test: {
      tag: 'Client Success',
      title: 'What Our Clients Say',
      roles: {
        homeowner: 'Homeowner',
        business: 'Business Owner',
        investor: 'Property Investor',
      },
      t1: 'After the hurricane, my insurance company offered me a fraction of what I needed to fix my roof and interior. Elite stepped in, handled everything, and got me 3x the original offer. True professionals.',
      t2: 'A pipe burst in our commercial building causing massive damage. Elite Property Adjusters took the stress off our shoulders. They documented every detail and secured a settlement that saved our business.',
      t3: "I've used Elite for multiple properties now. Their expertise in policy language and negotiation tactics is unmatched. I won't file a claim without them.",
    },
    contact: {
      tag: 'Get In Touch',
      title: 'Ready to Maximize Your Claim?',
      desc: "Don't face the insurance company alone. Contact Elite Property Adjusters LLC today for a free, no-obligation consultation and property inspection.",
      call: 'Call Us 24/7',
      email: 'Email Us',
      office: 'Office Location',
      hours: 'Business Hours',
      hoursDesc: 'Mon - Fri: 8:00 AM - 6:00 PM\nEmergency Services: 24/7',
      form: {
        title: 'Request a Free Consultation',
        fn: 'First Name',
        ln: 'Last Name',
        phone: 'Phone Number',
        email: 'Email Address',
        type: 'Type of Damage',
        msg: 'Message (Optional)',
        submit: 'Submit Request',
        options: [
          'Water Damage',
          'Fire & Smoke',
          'Storm / Hurricane',
          'Roof Damage',
          'Mold Damage',
          'Other',
        ],
      },
    },
    footer: {
      desc: 'Dedicated to protecting property owners and maximizing insurance claim settlements with integrity, expertise, and aggressive negotiation.',
      quick: 'Quick Links',
      services: 'Services',
      disclaimer: 'Disclaimer',
      disclaimerText:
        'This website is for informational purposes only and does not constitute legal advice. Elite Property Adjusters LLC is a licensed public adjusting firm. We do not guarantee specific outcomes, as each claim is unique.',
      rights: 'All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
    },
    free: {
      back: 'Back to Home',
      badge: 'Step 1 of Our Process',
      title: 'Free Property Inspection',
      desc: 'The foundation of every successful insurance claim starts with a thorough, professional inspection. At Elite Property Adjusters LLC, our free inspection is the critical first step to maximizing your settlement.',
      uTag: 'Understanding the Process',
      uTitle: "What Is a Public Adjuster's First Inspection?",
      uP1: "A public adjuster's first inspection is a comprehensive, on-site evaluation of your property after damage has occurred. Unlike the insurance company's adjuster — who works for the insurer — our public adjuster works exclusively for <strong>you</strong>, the policyholder.",
      uP2: 'During this initial visit, we assess every aspect of the damage: structural, cosmetic, hidden, and secondary. This inspection forms the backbone of your entire claim and directly impacts how much compensation you receive.',
      freeBadge: 'Free & No\nObligation',
      wTag: 'Why It Matters',
      wTitle: 'Why the First Inspection Is Critical',
      wDesc:
        'Insurance companies routinely undervalue claims. A professional first inspection ensures nothing is missed and sets the stage for maximum recovery.',
      w1Title: 'Uncover Hidden Damage',
      w1Desc:
        'Water intrusion behind walls, structural weakening, mold growth — damage often extends far beyond what the eye can see. Our trained adjusters know exactly where to look.',
      w2Title: 'Professional Documentation',
      w2Desc:
        'We create detailed photographic and written documentation that meets insurance industry standards. This evidence is crucial for supporting your claim amount.',
      w3Title: 'Accurate Scope of Loss',
      w3Desc:
        'We use industry-standard estimating software (Xactimate) to prepare a comprehensive scope of loss that reflects the true cost of repairs.',
      cTag: 'Comprehensive Coverage',
      cTitle: 'What We Inspect During Our Visit',
      cItems: [
        'Roof and exterior structural damage',
        'Interior walls, ceilings, and flooring',
        'Plumbing and water intrusion points',
        'Electrical systems affected by damage',
        'HVAC systems and ductwork',
        'Foundation and structural integrity',
        'Mold and moisture readings',
        'Personal property and contents damage',
        'Smoke and soot penetration areas',
        'Landscaping and exterior property',
      ],
      dTag: 'Know the Difference',
      dTitle: 'Their Adjuster vs. Your Adjuster',
      dTheirTitle: "Insurance Company's Adjuster",
      dTheirItems: [
        'Works for the insurance company',
        'Goal: minimize the payout',
        'May overlook or undervalue damage',
        'Quick, surface-level inspections',
        'Uses estimates that favor the insurer',
      ],
      dEliteTitle: 'Elite Property Adjusters',
      dEliteItems: [
        'Works exclusively for YOU',
        'Goal: maximize your settlement',
        'Thorough, detailed damage assessment',
        'Comprehensive multi-point inspection',
        'Uses Xactimate for accurate estimates',
      ],
      aTag: 'After the Inspection',
      aTitle: 'What Happens Next?',
      a1Title: 'We Review Our Findings With You',
      a1Desc:
        'After the inspection, we sit down with you to explain exactly what we found, the extent of the damage, and what your policy should cover. Full transparency — no surprises.',
      a2Title: 'We Prepare a Detailed Claim Package',
      a2Desc:
        'Using our inspection data, photographs, moisture readings, and Xactimate estimates, we compile a professional claim package designed to support the maximum settlement.',
      a3Title: 'We File & Negotiate on Your Behalf',
      a3Desc:
        'We submit the claim to your insurance company and handle all communication, meetings, and negotiations. You focus on your life — we handle the fight.',
      ctaTitle: 'Schedule Your Free Inspection Today',
      ctaDesc:
        "Don't let the insurance company dictate what your claim is worth. Let Elite Property Adjusters fight for the settlement you deserve.",
    },
    consult: {
      badge: 'Free Consultation',
      title: 'Request a Free Consultation',
      desc: 'Fill out the form below with your information and details about your loss. Your request will be sent directly to our team via WhatsApp for the fastest response.',
      formTitle: 'Send via WhatsApp',
      formSubtitle: 'Your information will be sent securely to our team',
      lossSection: 'Loss Information',
      selectOption: '-- Select Type of Loss --',
      lossTypes: [
        'Water Damage',
        'Fire & Smoke Damage',
        'Storm / Hurricane',
        'Roof Damage',
        'Mold Damage',
        'Flood Damage',
        'Other',
      ],
      fields: {
        fullName: 'Full Name',
        phone: 'Phone Number',
        email: 'Email Address',
        address: 'Property Address',
        lossType: 'Type of Loss',
        lossDate: 'Date of Loss',
        insurance: 'Insurance Company',
        policy: 'Policy Number',
        description: 'Describe the Damage',
      },
      submit: 'Send to WhatsApp',
      waMsg: '🏠 *New Consultation Request - Elite Property Adjusters*',
      note: 'By clicking "Send to WhatsApp," you will be redirected to WhatsApp with your information pre-filled. No data is stored on our website.',
    },
    serviceDetails: {
      'water-damage': {
        title: 'Water Damage Claims',
        intro:
          'Water damage is one of the most common and destructive issues property owners face. From burst pipes to appliance leaks, water can silently destroy your property.',
        whatIs:
          'Water damage refers to losses caused by sudden and accidental discharge of water from plumbing, appliances, or HVAC systems. It can cause immediate structural damage and lead to secondary issues like mold if not addressed quickly.',
        causes: [
          'Burst or leaking pipes',
          'Appliance failures (washing machines, dishwashers)',
          'Water heater leaks',
          'HVAC leaks or overflows',
          'Toilet or sink overflows',
        ],
        covered: [
          'Tear out and replacement of damaged materials',
          'Drying and mitigation services',
          'Repair of walls, floors, and ceilings',
          'Damage to personal property and contents',
          'Additional living expenses if the home is uninhabitable',
        ],
        recoveryRange: '$5,000 - $100,000+',
        recoveryNote:
          'Recovery amounts vary widely based on the extent of the damage, the materials affected (e.g., hardwood floors vs. carpet), and how quickly mitigation begins.',
        whyAdjuster:
          'Insurance companies often try to minimize water damage claims by classifying them as "long-term leaks" (which are often excluded) or by underestimating the cost to properly dry and restore the property. We use advanced moisture mapping and Xactimate estimating to prove the full extent of the loss.',
        caseTitle: 'Case Example: Burst Pipe',
        caseBefore: 'Insurance Offer: $8,500 (Covered visible damage only)',
        caseAfter:
          'Elite Recovery: $42,000 (Included hidden moisture damage behind cabinets and full continuous flooring replacement)',
        ctaTitle: 'Suffered Water Damage?',
        ctaDesc:
          'Contact us immediately. Fast action and proper documentation are critical for water claims.',
      },
      'fire-smoke-damage': {
        title: 'Fire & Smoke Damage Claims',
        intro:
          'Fires cause devastating primary damage, but the secondary damage from smoke, soot, and the water used to extinguish the flames can be just as destructive.',
        whatIs:
          'Fire claims encompass the physical destruction caused by flames, the pervasive damage from smoke and soot, and the water/chemical damage resulting from firefighting efforts.',
        causes: [
          'Electrical shorts or wiring issues',
          'Kitchen/cooking accidents',
          'Heating equipment malfunctions',
          'Lightning strikes',
          'Wildfires or neighboring property fires',
        ],
        covered: [
          'Structural rebuilding and repairs',
          'Smoke and soot remediation',
          'Cleaning or replacement of personal property',
          'Code upgrades (if policy allows)',
          'Alternative living arrangements (ALE) or business interruption',
        ],
        recoveryRange: '$20,000 - $500,000+',
        recoveryNote:
          'Fire claims are typically high-value due to the need for specialized cleaning, structural rebuilding, and extensive personal property replacement.',
        whyAdjuster:
          'Smoke and soot can penetrate deep into walls, HVAC systems, and porous materials. Insurers often suggest simply "cleaning" items that actually require full replacement. We fight to ensure your property is restored to its pre-loss condition, not just superficially cleaned.',
        caseTitle: 'Case Example: Kitchen Fire',
        caseBefore:
          'Insurance Offer: $35,000 (Kitchen rebuild and basic cleaning)',
        caseAfter:
          'Elite Recovery: $115,000 (Included full HVAC replacement due to soot contamination and extensive content replacement)',
        ctaTitle: 'Devastated by Fire?',
        ctaDesc:
          "Don't accept the insurance company's initial cleaning offer. Let us evaluate the true extent of the smoke and structural damage.",
      },
      'storm-hurricane': {
        title: 'Storm & Hurricane Claims',
        intro:
          'Severe weather can cause catastrophic damage in minutes. Navigating the complex deductibles and policy limits after a major storm requires expert help.',
        whatIs:
          'Storm damage includes destruction caused by high winds, hail, tornadoes, and hurricanes. This often involves roof damage, broken windows, water intrusion, and structural compromise.',
        causes: [
          'Hurricanes and tropical storms',
          'Tornadoes and straight-line winds',
          'Severe hailstorms',
          'Fallen trees or flying debris',
          'Wind-driven rain',
        ],
        covered: [
          'Roof repair or full replacement',
          'Siding and exterior damage',
          'Window and door replacement',
          'Interior water damage resulting from exterior breaches',
          'Fallen tree removal (if it hit a covered structure)',
        ],
        recoveryRange: '$10,000 - $250,000+',
        recoveryNote:
          'Storm claims often involve multiple types of damage (wind, water, impact) and may trigger special hurricane deductibles.',
        whyAdjuster:
          'After a major storm, insurance companies are overwhelmed and often send out out-of-state adjusters who miss local building code requirements or rush inspections. We take the time to document every detail and fight for a complete restoration.',
        caseTitle: 'Case Example: Hurricane Wind Damage',
        caseBefore:
          'Insurance Offer: $18,000 (Patching roof and minor interior paint)',
        caseAfter:
          'Elite Recovery: $85,000 (Proved need for full roof replacement to meet current wind codes and extensive interior water damage repair)',
        ctaTitle: 'Hit by a Severe Storm?',
        ctaDesc:
          'Protect your investment. Get a professional assessment before accepting a rushed settlement.',
      },
      'roof-claims': {
        title: 'Roof Damage Claims',
        intro:
          "Your roof is your property's first line of defense. When it fails due to a covered peril, the resulting damage can be extensive.",
        whatIs:
          'Roof claims involve damage to shingles, tiles, underlayment, or the roof structure itself, usually caused by weather events or sudden impacts.',
        causes: [
          'Hail impacts',
          'High winds lifting or tearing shingles',
          'Fallen trees or branches',
          'Lightning strikes',
          'Weight of ice or snow',
        ],
        covered: [
          'Repair or replacement of damaged roofing materials',
          'Replacement of underlayment and decking',
          'Interior water damage caused by the roof leak',
          'Gutter and fascia damage',
        ],
        recoveryRange: '$8,000 - $75,000+',
        recoveryNote:
          'The recovery depends heavily on the size of the roof, the materials used (e.g., asphalt vs. tile or metal), and local building codes.',
        whyAdjuster:
          'Insurance companies frequently deny roof claims by blaming "wear and tear" or age, or they offer to only patch a small section. We work with roofing experts and engineers to prove the damage was caused by a covered event and fight for a full replacement when repairs aren\'t feasible.',
        caseTitle: 'Case Example: Wind-Damaged Roof',
        caseBefore: 'Insurance Offer: $2,500 (Repair of 15 missing shingles)',
        caseAfter:
          'Elite Recovery: $28,000 (Proved the shingles were discontinued and could not be matched, resulting in a full roof replacement)',
        ctaTitle: 'Roof Leaking or Damaged?',
        ctaDesc:
          "Don't settle for a patch job. Let us inspect your roof and secure the funds for a proper replacement.",
      },
      'mold-damage': {
        title: 'Mold Damage Claims',
        intro:
          'Mold is a serious health hazard and a complex insurance issue. It requires specialized testing, remediation, and careful policy navigation.',
        whatIs:
          'Mold claims involve the growth of fungi resulting from a covered water loss. Because mold grows over time, these claims are heavily scrutinized by insurers.',
        causes: [
          'Hidden pipe leaks',
          'Inadequately dried water damage',
          'Roof leaks',
          'Appliance failures',
          'HVAC condensation issues',
        ],
        covered: [
          'Mold testing and assessment',
          'Professional mold remediation and removal',
          'Tear out of contaminated materials',
          'Reconstruction of the affected area',
          'Often subject to specific policy limits (e.g., $10,000 cap)',
        ],
        recoveryRange: '$10,000 - $150,000+',
        recoveryNote:
          'Many policies have strict caps on mold remediation (often $10,000), but the underlying water damage that caused the mold may not be capped.',
        whyAdjuster:
          'Insurers often use mold as an excuse to deny the entire claim, citing "long-term seepage." We know how to properly present the claim, separating the sudden water damage from the resulting mold, to maximize your available coverage.',
        caseTitle: 'Case Example: Hidden Bathroom Leak',
        caseBefore:
          'Insurance Offer: Denied (Claimed long-term leak and excluded mold)',
        caseAfter:
          'Elite Recovery: $55,000 (Proved the leak was sudden, secured the $10k mold limit, and $45k for the underlying water damage and rebuild)',
        ctaTitle: 'Discovered Mold?',
        ctaDesc:
          'Mold claims are frequently denied. Contact us before filing so we can properly position your claim.',
      },
      'flood-claims': {
        title: 'Flood Claims',
        intro:
          'Flood insurance is entirely different from standard property insurance. Navigating FEMA regulations and NFIP policies requires specialized expertise.',
        whatIs:
          'A flood is defined as a general and temporary condition of partial or complete inundation of two or more acres of normally dry land area or of two or more properties.',
        causes: [
          'Overflow of inland or tidal waters',
          'Unusual and rapid accumulation or runoff of surface waters',
          'Mudflows',
          'Storm surges from hurricanes',
        ],
        covered: [
          'Structural damage to the building',
          'Electrical and plumbing systems',
          'Furnaces and water heaters',
          'Debris removal',
          'Contents (if a separate contents policy was purchased)',
        ],
        recoveryRange: '$15,000 - $200,000+',
        recoveryNote:
          'NFIP policies have strict limits (typically $250,000 for residential buildings and $100,000 for contents) and do not cover additional living expenses (ALE).',
        whyAdjuster:
          'FEMA/NFIP claims have incredibly strict deadlines and proof of loss requirements. A single mistake can result in a total denial. We handle the complex paperwork, ensure all damages are properly categorized, and fight for every dollar allowed under the strict federal guidelines.',
        caseTitle: 'Case Example: Storm Surge Flooding',
        caseBefore:
          'Insurance Offer: $45,000 (Undervalued structural drying and repair costs)',
        caseAfter:
          'Elite Recovery: $142,000 (Submitted detailed Xactimate estimates proving the true cost of remediation and repair under NFIP guidelines)',
        ctaTitle: 'Property Flooded?',
        ctaDesc:
          "Flood claims have strict federal deadlines. Don't delay—contact us to handle the complex NFIP process.",
      },
    },
    privacy: {
      badge: 'Legal',
      title: 'Privacy Policy',
      lastUpdated: 'Last updated: January 2025',
      intro:
        'Elite Property Adjusters LLC ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.',
      contactTitle: 'Contact Us About Privacy',
      contactText:
        'If you have questions or concerns about this Privacy Policy or our data practices, please contact us:',
      sections: [
        {
          heading: 'Information We Collect',
          content:
            'We may collect personal information that you voluntarily provide to us when you fill out our contact form, request a consultation, or communicate with us. This includes your name, email address, phone number, property address, and details about your insurance claim or property damage.',
        },
        {
          heading: 'How We Use Your Information',
          content:
            'We use the information we collect to respond to your inquiries, provide our public adjusting services, communicate with you about your claim, send you relevant updates, improve our website and services, and comply with legal obligations.',
        },
        {
          heading: 'Information Sharing',
          content:
            'We do not sell, trade, or rent your personal information to third parties. We may share your information with insurance companies as part of the claims process (with your authorization), trusted service providers who assist in our operations, and as required by law or to protect our legal rights.',
        },
        {
          heading: 'Data Security',
          content:
            'We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.',
        },
        {
          heading: 'Cookies and Tracking',
          content:
            'Our website may use cookies and similar tracking technologies to enhance your browsing experience, analyze site traffic, and understand where our visitors come from. You can control cookie settings through your browser preferences.',
        },
        {
          heading: 'Third-Party Links',
          content:
            'Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to review the privacy policies of any third-party sites you visit.',
        },
        {
          heading: 'Your Rights',
          content:
            'You have the right to access, correct, or delete your personal information. You may also opt out of receiving marketing communications from us at any time by contacting us directly or using the unsubscribe option in our emails.',
        },
        {
          heading: "Children's Privacy",
          content:
            'Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children.',
        },
        {
          heading: 'Changes to This Policy',
          content:
            'We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date. We encourage you to review this policy periodically.',
        },
      ],
    },
    terms: {
      badge: 'Legal',
      title: 'Terms of Service',
      lastUpdated: 'Last updated: January 2025',
      intro:
        'Welcome to the website of Elite Property Adjusters LLC. By accessing or using our website and services, you agree to be bound by these Terms of Service. Please read them carefully before using our site.',
      contactTitle: 'Contact Us',
      contactText:
        'If you have any questions about these Terms of Service, please contact us:',
      sections: [
        {
          heading: 'Acceptance of Terms',
          content:
            'By accessing and using this website, you accept and agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree to these terms, please do not use our website or services.',
        },
        {
          heading: 'Services Description',
          content:
            'Elite Property Adjusters LLC is a licensed public adjusting firm that assists property owners with insurance claims. Our services include property inspections, damage documentation, claim filing, and negotiation with insurance companies on behalf of our clients.',
        },
        {
          heading: 'No Guarantee of Results',
          content:
            "While we strive to maximize every client's insurance claim settlement, we cannot and do not guarantee specific outcomes. Each claim is unique, and results depend on many factors including policy terms, extent of damage, and insurance company decisions.",
        },
        {
          heading: 'Professional Relationship',
          content:
            'Use of this website does not create a professional or contractual relationship between you and Elite Property Adjusters LLC. A formal engagement begins only upon signing a written agreement with our firm.',
        },
        {
          heading: 'Website Content',
          content:
            'The information provided on this website is for general informational purposes only and does not constitute legal, financial, or professional advice. While we strive to keep information accurate and up-to-date, we make no warranties about the completeness or accuracy of the content.',
        },
        {
          heading: 'Intellectual Property',
          content:
            'All content on this website, including text, graphics, logos, images, and software, is the property of Elite Property Adjusters LLC and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without our written permission.',
        },
        {
          heading: 'User Conduct',
          content:
            'You agree not to use our website for any unlawful purpose, attempt to gain unauthorized access to our systems, transmit any harmful code or malware, or interfere with the proper functioning of the website.',
        },
        {
          heading: 'Limitation of Liability',
          content:
            'Elite Property Adjusters LLC shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of this website or our services. Our total liability shall not exceed the fees paid for our services.',
        },
        {
          heading: 'Governing Law',
          content:
            'These Terms of Service are governed by and construed in accordance with the laws of the State of Florida. Any disputes arising from these terms shall be resolved in the courts of Miami-Dade County, Florida.',
        },
        {
          heading: 'Changes to Terms',
          content:
            'We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to this website. Your continued use of the website after changes constitutes acceptance of the updated terms.',
        },
      ],
    },
  },
  es: {
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      about: 'Nosotros',
      process: 'Proceso',
      testimonials: 'Testimonios',
      contact: 'Contacto',
      topbar: 'Ajustadores Públicos Licenciados — Disponibles 24/7',
      freeConsultation: 'Consulta Gratis',
      call: 'Llamar',
    },
    hero: {
      badge: 'Ajustadores Públicos Licenciados',
      title: 'ELITE',
      subtitle: 'Property Adjusters LLC',
      desc: 'Maximizamos el acuerdo de su reclamo de seguro. Luchamos por la compensación que merece cuando un desastre golpea su hogar o negocio.',
      cta1: 'Obtenga una Consulta Gratis',
      cta2: 'Nuestros Servicios',
      stats: {
        s1: 'Años de Experiencia',
        s2: 'Disponibles 24/7',
        s3: 'Reclamos Manejados',
        s4: 'Millones Recuperados',
      },
    },
    services: {
      tag: 'Áreas de Experiencia',
      title: 'Tipos de Reclamos que Manejamos',
      desc: 'Las compañías de seguros tienen sus propios ajustadores cuidando sus intereses. Usted necesita un ajustador Elite cuidando los suyos.',
      items: [
        {
          title: 'Daños por Agua',
          desc: 'Tuberías rotas, fugas y fallas de plomería pueden causar daños estructurales ocultos y moho. Nos aseguramos de que todos los daños sean contabilizados.',
        },
        {
          title: 'Daños por Fuego y Humo',
          desc: 'Más allá de la quemadura visible, el humo y el hollín pueden arruinar la propiedad. Documentamos meticulosamente todos los daños primarios y secundarios.',
        },
        {
          title: 'Tormentas y Huracanes',
          desc: 'Los fuertes vientos y escombros voladores pueden devastar su propiedad. Nos especializamos en reclamos complejos por tormentas catastróficas.',
        },
        {
          title: 'Reclamos de Techo',
          desc: 'Ya sea por granizo, viento o fallas relacionadas con la edad exacerbadas por el clima, luchamos por reemplazos completos de techo cuando se justifica.',
        },
        {
          title: 'Daños por Moho',
          desc: 'El moho requiere remediación especializada. Trabajamos con expertos para probar la causa y asegurar fondos para una limpieza adecuada.',
        },
        {
          title: 'Reclamos por Inundación',
          desc: 'Navegar por las políticas de inundación privadas y de FEMA es complejo. Manejamos la burocracia para maximizar su recuperación por inundación.',
        },
      ],
    },
    why: {
      tag: 'Por Qué Elegir Elite',
      title: 'Nivelamos el Campo de Juego',
      desc: 'Cuando presenta un reclamo de seguro, la compañía de seguros envía a su propio ajustador para proteger sus intereses. En Elite Property Adjusters LLC, trabajamos exclusivamente para <strong>usted</strong>. Nuestro objetivo es asegurar que reciba el acuerdo máximo permitido bajo su póliza.',
      benefits: [
        'Sin Cargos por Adelantado - Solo cobramos cuando usted cobra',
        'Profesionales Licenciados y Certificados',
        'Maximizamos el Acuerdo de su Reclamo',
        'Manejamos Todas las Comunicaciones con el Seguro',
        'Documentación y Estimación Detallada de Daños',
        'Proceso Sin Estrés para los Propietarios',
      ],
      cta: 'Hable con un Experto Hoy',
      exp1: '5+',
      exp2: 'Años de\nExperiencia',
    },
    process: {
      tag: 'Nuestro Proceso',
      title: 'Cómo Maximizamos su Reclamo',
      step: 'Paso',
      learnMore: 'Saber Más',
      steps: [
        {
          title: 'Inspección Gratuita',
          desc: 'Realizamos una inspección exhaustiva y sin compromiso de su propiedad para evaluar la magnitud total de los daños.',
        },
        {
          title: 'Documentar y Presentar',
          desc: 'Documentamos meticulosamente todos los daños, preparamos estimaciones profesionales y presentamos oficialmente su reclamo.',
        },
        {
          title: 'Negociar',
          desc: 'Nos reunimos con los ajustadores de la compañía de seguros y negociamos agresivamente en su nombre.',
        },
        {
          title: 'Recibir el Pago',
          desc: 'Aseguramos el acuerdo máximo posible para que pueda restaurar adecuadamente su propiedad.',
        },
      ],
    },
    test: {
      tag: 'Éxito del Cliente',
      title: 'Lo Que Dicen Nuestros Clientes',
      roles: {
        homeowner: 'Propietario',
        business: 'Dueño de Negocio',
        investor: 'Inversor Inmobiliario',
      },
      t1: 'Después del huracán, mi compañía de seguros me ofreció una fracción de lo que necesitaba para arreglar mi techo e interior. Elite intervino, manejó todo y me consiguió 3 veces la oferta original. Verdaderos profesionales.',
      t2: 'Una tubería estalló en nuestro edificio comercial causando daños masivos. Elite Property Adjusters nos quitó el estrés de encima. Documentaron cada detalle y aseguraron un acuerdo que salvó nuestro negocio.',
      t3: 'He usado a Elite para múltiples propiedades. Su experiencia en el lenguaje de las pólizas y tácticas de negociación es inigualable. No presentaré un reclamo sin ellos.',
    },
    contact: {
      tag: 'Póngase en Contacto',
      title: '¿Listo para Maximizar su Reclamo?',
      desc: 'No enfrente a la compañía de seguros solo. Contacte a Elite Property Adjusters LLC hoy para una consulta e inspección de propiedad gratuita y sin compromiso.',
      call: 'Llámenos 24/7',
      email: 'Envíenos un Correo',
      office: 'Ubicación de la Oficina',
      hours: 'Horario de Atención',
      hoursDesc: 'Lun - Vie: 8:00 AM - 6:00 PM\nServicios de Emergencia: 24/7',
      form: {
        title: 'Solicite una Consulta Gratuita',
        fn: 'Nombre',
        ln: 'Apellido',
        phone: 'Número de Teléfono',
        email: 'Correo Electrónico',
        type: 'Tipo de Daño',
        msg: 'Mensaje (Opcional)',
        submit: 'Enviar Solicitud',
        options: [
          'Daños por Agua',
          'Fuego y Humo',
          'Tormenta / Huracán',
          'Daños de Techo',
          'Daños por Moho',
          'Otro',
        ],
      },
    },
    footer: {
      desc: 'Dedicados a proteger a los propietarios y maximizar los acuerdos de reclamos de seguros con integridad, experiencia y negociación agresiva.',
      quick: 'Enlaces Rápidos',
      services: 'Servicios',
      disclaimer: 'Descargo de Responsabilidad',
      disclaimerText:
        'Este sitio web es solo para fines informativos y no constituye asesoramiento legal. Elite Property Adjusters LLC es una firma de ajustadores públicos licenciada. No garantizamos resultados específicos, ya que cada reclamo es único.',
      rights: 'Todos los derechos reservados.',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio',
    },
    free: {
      back: 'Volver al Inicio',
      badge: 'Paso 1 de Nuestro Proceso',
      title: 'Inspección de Propiedad Gratuita',
      desc: 'La base de todo reclamo de seguro exitoso comienza con una inspección exhaustiva y profesional. En Elite Property Adjusters LLC, nuestra inspección gratuita es el primer paso crítico para maximizar su acuerdo.',
      uTag: 'Entendiendo el Proceso',
      uTitle: '¿Qué es la Primera Inspección de un Ajustador Público?',
      uP1: 'La primera inspección de un ajustador público es una evaluación integral en el sitio de su propiedad después de que ha ocurrido un daño. A diferencia del ajustador de la compañía de seguros — que trabaja para la aseguradora — nuestro ajustador público trabaja exclusivamente para <strong>usted</strong>, el titular de la póliza.',
      uP2: 'Durante esta visita inicial, evaluamos cada aspecto del daño: estructural, cosmético, oculto y secundario. Esta inspección forma la columna vertebral de todo su reclamo e impacta directamente cuánta compensación recibe.',
      freeBadge: 'Gratis y Sin\nCompromiso',
      wTag: 'Por Qué es Importante',
      wTitle: 'Por Qué la Primera Inspección es Crítica',
      wDesc:
        'Las compañías de seguros subestiman rutinariamente los reclamos. Una primera inspección profesional asegura que no se pase nada por alto y prepara el escenario para la máxima recuperación.',
      w1Title: 'Descubrir Daños Ocultos',
      w1Desc:
        'Intrusión de agua detrás de las paredes, debilitamiento estructural, crecimiento de moho — el daño a menudo se extiende mucho más allá de lo que el ojo puede ver. Nuestros ajustadores capacitados saben exactamente dónde mirar.',
      w2Title: 'Documentación Profesional',
      w2Desc:
        'Creamos documentación fotográfica y escrita detallada que cumple con los estándares de la industria de seguros. Esta evidencia es crucial para respaldar el monto de su reclamo.',
      w3Title: 'Alcance Preciso de la Pérdida',
      w3Desc:
        'Utilizamos software de estimación estándar de la industria (Xactimate) para preparar un alcance de pérdida integral que refleja el verdadero costo de las reparaciones.',
      cTag: 'Cobertura Integral',
      cTitle: 'Lo Que Inspeccionamos Durante Nuestra Visita',
      cItems: [
        'Daños estructurales en el techo y exteriores',
        'Paredes interiores, techos y pisos',
        'Puntos de plomería e intrusión de agua',
        'Sistemas eléctricos afectados por daños',
        'Sistemas HVAC y conductos',
        'Cimientos e integridad estructural',
        'Lecturas de moho y humedad',
        'Daños a la propiedad personal y contenido',
        'Áreas de penetración de humo y hollín',
        'Paisajismo y propiedad exterior',
      ],
      dTag: 'Conozca la Diferencia',
      dTitle: 'Su Ajustador vs. Nuestro Ajustador',
      dTheirTitle: 'Ajustador de la Compañía de Seguros',
      dTheirItems: [
        'Trabaja para la compañía de seguros',
        'Objetivo: minimizar el pago',
        'Puede pasar por alto o subestimar daños',
        'Inspecciones rápidas y superficiales',
        'Usa estimaciones que favorecen a la aseguradora',
      ],
      dEliteTitle: 'Elite Property Adjusters',
      dEliteItems: [
        'Trabaja exclusivamente para USTED',
        'Objetivo: maximizar su acuerdo',
        'Evaluación exhaustiva y detallada de daños',
        'Inspección integral de múltiples puntos',
        'Usa Xactimate para estimaciones precisas',
      ],
      aTag: 'Después de la Inspección',
      aTitle: '¿Qué Pasa Después?',
      a1Title: 'Revisamos Nuestros Hallazgos Con Usted',
      a1Desc:
        'Después de la inspección, nos sentamos con usted para explicarle exactamente lo que encontramos, la magnitud de los daños y lo que su póliza debería cubrir. Transparencia total — sin sorpresas.',
      a2Title: 'Preparamos un Paquete de Reclamo Detallado',
      a2Desc:
        'Utilizando nuestros datos de inspección, fotografías, lecturas de humedad y estimaciones de Xactimate, compilamos un paquete de reclamo profesional diseñado para respaldar el acuerdo máximo.',
      a3Title: 'Presentamos y Negociamos en su Nombre',
      a3Desc:
        'Presentamos el reclamo a su compañía de seguros y manejamos todas las comunicaciones, reuniones y negociaciones. Usted se enfoca en su vida — nosotros manejamos la pelea.',
      ctaTitle: 'Programe su Inspección Gratuita Hoy',
      ctaDesc:
        'No deje que la compañía de seguros dicte cuánto vale su reclamo. Deje que Elite Property Adjusters luche por el acuerdo que merece.',
    },
    consult: {
      badge: 'Consulta Gratis',
      title: 'Solicite una Consulta Gratuita',
      desc: 'Complete el formulario a continuación con su información y los detalles de su pérdida. Su solicitud será enviada directamente a nuestro equipo por WhatsApp para la respuesta más rápida.',
      formTitle: 'Enviar por WhatsApp',
      formSubtitle:
        'Su información será enviada de forma segura a nuestro equipo',
      lossSection: 'Información de la Pérdida',
      selectOption: '-- Seleccione Tipo de Pérdida --',
      lossTypes: [
        'Daños por Agua',
        'Daños por Fuego y Humo',
        'Tormenta / Huracán',
        'Daños de Techo',
        'Daños por Moho',
        'Daños por Inundación',
        'Otro',
      ],
      fields: {
        fullName: 'Nombre Completo',
        phone: 'Número de Teléfono',
        email: 'Correo Electrónico',
        address: 'Dirección de la Propiedad',
        lossType: 'Tipo de Pérdida',
        lossDate: 'Fecha de la Pérdida',
        insurance: 'Compañía de Seguros',
        policy: 'Número de Póliza',
        description: 'Describa los Daños',
      },
      submit: 'Enviar por WhatsApp',
      waMsg: '🏠 *Nueva Solicitud de Consulta - Elite Property Adjusters*',
      note: 'Al hacer clic en "Enviar por WhatsApp," será redirigido a WhatsApp con su información prellenada. No se almacenan datos en nuestro sitio web.',
    },
    serviceDetails: {
      'water-damage': {
        title: 'Reclamos por Daños de Agua',
        intro:
          'El daño por agua es uno de los problemas más comunes y destructivos que enfrentan los propietarios. Desde tuberías rotas hasta fugas de electrodomésticos, el agua puede destruir silenciosamente su propiedad.',
        whatIs:
          'El daño por agua se refiere a las pérdidas causadas por la descarga repentina y accidental de agua de plomería, electrodomésticos o sistemas HVAC. Puede causar daños estructurales inmediatos y provocar problemas secundarios como moho si no se aborda rápidamente.',
        causes: [
          'Tuberías rotas o con fugas',
          'Fallas de electrodomésticos (lavadoras, lavavajillas)',
          'Fugas del calentador de agua',
          'Fugas o desbordamientos de HVAC',
          'Desbordamientos de inodoros o lavabos',
        ],
        covered: [
          'Extracción y reemplazo de materiales dañados',
          'Servicios de secado y mitigación',
          'Reparación de paredes, pisos y techos',
          'Daños a la propiedad personal y contenido',
          'Gastos de vida adicionales si la casa es inhabitable',
        ],
        recoveryRange: '$5,000 - $100,000+',
        recoveryNote:
          'Los montos de recuperación varían ampliamente según la magnitud del daño, los materiales afectados (ej. pisos de madera vs. alfombra) y qué tan rápido comienza la mitigación.',
        whyAdjuster:
          'Las compañías de seguros a menudo intentan minimizar los reclamos por daños de agua clasificándolos como "fugas a largo plazo" (que a menudo están excluidas) o subestimando el costo de secar y restaurar adecuadamente la propiedad. Usamos mapeo de humedad avanzado y estimaciones de Xactimate para probar la magnitud total de la pérdida.',
        caseTitle: 'Ejemplo de Caso: Tubería Rota',
        caseBefore: 'Oferta del Seguro: $8,500 (Solo cubrió daños visibles)',
        caseAfter:
          'Recuperación de Elite: $42,000 (Incluyó daños ocultos por humedad detrás de los gabinetes y reemplazo completo y continuo del piso)',
        ctaTitle: '¿Sufrió Daños por Agua?',
        ctaDesc:
          'Contáctenos de inmediato. La acción rápida y la documentación adecuada son críticas para los reclamos de agua.',
      },
      'fire-smoke-damage': {
        title: 'Reclamos por Daños de Fuego y Humo',
        intro:
          'Los incendios causan daños primarios devastadores, pero los daños secundarios del humo, el hollín y el agua utilizada para extinguir las llamas pueden ser igual de destructivos.',
        whatIs:
          'Los reclamos de incendio abarcan la destrucción física causada por las llamas, el daño penetrante del humo y el hollín, y el daño por agua/químicos resultante de los esfuerzos de extinción de incendios.',
        causes: [
          'Cortocircuitos eléctricos o problemas de cableado',
          'Accidentes de cocina',
          'Mal funcionamiento del equipo de calefacción',
          'Caída de rayos',
          'Incendios forestales o incendios en propiedades vecinas',
        ],
        covered: [
          'Reconstrucción y reparaciones estructurales',
          'Remediación de humo y hollín',
          'Limpieza o reemplazo de propiedad personal',
          'Actualizaciones de código (si la póliza lo permite)',
          'Arreglos de vivienda alternativos (ALE) o interrupción del negocio',
        ],
        recoveryRange: '$20,000 - $500,000+',
        recoveryNote:
          'Los reclamos de incendio suelen ser de alto valor debido a la necesidad de limpieza especializada, reconstrucción estructural y reemplazo extenso de propiedad personal.',
        whyAdjuster:
          'El humo y el hollín pueden penetrar profundamente en las paredes, los sistemas HVAC y los materiales porosos. Las aseguradoras a menudo sugieren simplemente "limpiar" artículos que en realidad requieren un reemplazo completo. Luchamos para garantizar que su propiedad sea restaurada a su condición anterior a la pérdida, no solo limpiada superficialmente.',
        caseTitle: 'Ejemplo de Caso: Incendio en la Cocina',
        caseBefore:
          'Oferta del Seguro: $35,000 (Reconstrucción de la cocina y limpieza básica)',
        caseAfter:
          'Recuperación de Elite: $115,000 (Incluyó el reemplazo completo de HVAC debido a la contaminación por hollín y el reemplazo extenso de contenido)',
        ctaTitle: '¿Devastado por un Incendio?',
        ctaDesc:
          'No acepte la oferta de limpieza inicial de la compañía de seguros. Permítanos evaluar la verdadera magnitud del daño estructural y por humo.',
      },
      'storm-hurricane': {
        title: 'Reclamos por Tormentas y Huracanes',
        intro:
          'El clima severo puede causar daños catastróficos en minutos. Navegar por los complejos deducibles y límites de la póliza después de una gran tormenta requiere ayuda experta.',
        whatIs:
          'Los daños por tormentas incluyen la destrucción causada por fuertes vientos, granizo, tornados y huracanes. Esto a menudo implica daños en el techo, ventanas rotas, intrusión de agua y compromiso estructural.',
        causes: [
          'Huracanes y tormentas tropicales',
          'Tornados y vientos en línea recta',
          'Tormentas de granizo severas',
          'Árboles caídos o escombros voladores',
          'Lluvia impulsada por el viento',
        ],
        covered: [
          'Reparación o reemplazo completo del techo',
          'Daños en el revestimiento y exteriores',
          'Reemplazo de ventanas y puertas',
          'Daños por agua en el interior resultantes de brechas exteriores',
          'Remoción de árboles caídos (si golpeó una estructura cubierta)',
        ],
        recoveryRange: '$10,000 - $250,000+',
        recoveryNote:
          'Los reclamos por tormentas a menudo involucran múltiples tipos de daños (viento, agua, impacto) y pueden activar deducibles especiales para huracanes.',
        whyAdjuster:
          'Después de una gran tormenta, las compañías de seguros están abrumadas y a menudo envían ajustadores de otros estados que pasan por alto los requisitos del código de construcción local o apresuran las inspecciones. Nos tomamos el tiempo para documentar cada detalle y luchar por una restauración completa.',
        caseTitle: 'Ejemplo de Caso: Daños por Viento de Huracán',
        caseBefore:
          'Oferta del Seguro: $18,000 (Parcheo del techo y pintura interior menor)',
        caseAfter:
          'Recuperación de Elite: $85,000 (Demostró la necesidad de un reemplazo completo del techo para cumplir con los códigos de viento actuales y reparación extensa de daños por agua en el interior)',
        ctaTitle: '¿Golpeado por una Tormenta Severa?',
        ctaDesc:
          'Proteja su inversión. Obtenga una evaluación profesional antes de aceptar un acuerdo apresurado.',
      },
      'roof-claims': {
        title: 'Reclamos de Techo',
        intro:
          'Su techo es la primera línea de defensa de su propiedad. Cuando falla debido a un peligro cubierto, el daño resultante puede ser extenso.',
        whatIs:
          'Los reclamos de techo involucran daños a las tejas, el contrapiso o la estructura del techo en sí, generalmente causados por eventos climáticos o impactos repentinos.',
        causes: [
          'Impactos de granizo',
          'Fuertes vientos que levantan o arrancan tejas',
          'Árboles o ramas caídas',
          'Caída de rayos',
          'Peso del hielo o la nieve',
        ],
        covered: [
          'Reparación o reemplazo de materiales de techado dañados',
          'Reemplazo del contrapiso y la plataforma',
          'Daños por agua en el interior causados por la fuga del techo',
          'Daños en canaletas y fascias',
        ],
        recoveryRange: '$8,000 - $75,000+',
        recoveryNote:
          'La recuperación depende en gran medida del tamaño del techo, los materiales utilizados (ej. asfalto vs. teja o metal) y los códigos de construcción locales.',
        whyAdjuster:
          'Las compañías de seguros frecuentemente niegan los reclamos de techo culpando al "desgaste" o la edad, o se ofrecen a parchear solo una pequeña sección. Trabajamos con expertos en techos e ingenieros para demostrar que el daño fue causado por un evento cubierto y luchamos por un reemplazo completo cuando las reparaciones no son factibles.',
        caseTitle: 'Ejemplo de Caso: Techo Dañado por el Viento',
        caseBefore:
          'Oferta del Seguro: $2,500 (Reparación de 15 tejas faltantes)',
        caseAfter:
          'Recuperación de Elite: $28,000 (Demostró que las tejas estaban descontinuadas y no se podían igualar, lo que resultó en un reemplazo completo del techo)',
        ctaTitle: '¿Techo con Fugas o Dañado?',
        ctaDesc:
          'No se conforme con un trabajo de parcheo. Permítanos inspeccionar su techo y asegurar los fondos para un reemplazo adecuado.',
      },
      'mold-damage': {
        title: 'Reclamos por Daños de Moho',
        intro:
          'El moho es un grave peligro para la salud y un problema de seguro complejo. Requiere pruebas especializadas, remediación y una cuidadosa navegación de la póliza.',
        whatIs:
          'Los reclamos por moho involucran el crecimiento de hongos resultante de una pérdida de agua cubierta. Debido a que el moho crece con el tiempo, estos reclamos son muy analizados por las aseguradoras.',
        causes: [
          'Fugas de tuberías ocultas',
          'Daños por agua secados inadecuadamente',
          'Fugas en el techo',
          'Fallas de electrodomésticos',
          'Problemas de condensación de HVAC',
        ],
        covered: [
          'Pruebas y evaluación de moho',
          'Remediación y eliminación profesional de moho',
          'Extracción de materiales contaminados',
          'Reconstrucción del área afectada',
          'A menudo sujeto a límites de póliza específicos (ej. límite de $10,000)',
        ],
        recoveryRange: '$10,000 - $150,000+',
        recoveryNote:
          'Muchas pólizas tienen límites estrictos en la remediación de moho (a menudo $10,000), pero el daño por agua subyacente que causó el moho puede no estar limitado.',
        whyAdjuster:
          'Las aseguradoras a menudo usan el moho como excusa para negar todo el reclamo, citando "filtración a largo plazo". Sabemos cómo presentar adecuadamente el reclamo, separando el daño repentino por agua del moho resultante, para maximizar su cobertura disponible.',
        caseTitle: 'Ejemplo de Caso: Fuga Oculta en el Baño',
        caseBefore:
          'Oferta del Seguro: Denegado (Reclamó fuga a largo plazo y excluyó el moho)',
        caseAfter:
          'Recuperación de Elite: $55,000 (Demostró que la fuga fue repentina, aseguró el límite de moho de $10k y $45k por el daño de agua subyacente y la reconstrucción)',
        ctaTitle: '¿Descubrió Moho?',
        ctaDesc:
          'Los reclamos por moho se niegan con frecuencia. Contáctenos antes de presentar el reclamo para que podamos posicionarlo adecuadamente.',
      },
      'flood-claims': {
        title: 'Reclamos por Inundación',
        intro:
          'El seguro contra inundaciones es completamente diferente del seguro de propiedad estándar. Navegar por las regulaciones de FEMA y las pólizas del NFIP requiere experiencia especializada.',
        whatIs:
          'Una inundación se define como una condición general y temporal de inundación parcial o completa de dos o más acres de área de tierra normalmente seca o de dos o más propiedades.',
        causes: [
          'Desbordamiento de aguas interiores o de marea',
          'Acumulación o escorrentía inusual y rápida de aguas superficiales',
          'Flujos de lodo',
          'Marejadas ciclónicas de huracanes',
        ],
        covered: [
          'Daños estructurales al edificio',
          'Sistemas eléctricos y de plomería',
          'Hornos y calentadores de agua',
          'Remoción de escombros',
          'Contenido (si se compró una póliza de contenido separada)',
        ],
        recoveryRange: '$15,000 - $200,000+',
        recoveryNote:
          'Las pólizas del NFIP tienen límites estrictos (típicamente $250,000 para edificios residenciales y $100,000 para contenido) y no cubren gastos de vida adicionales (ALE).',
        whyAdjuster:
          'Los reclamos de FEMA/NFIP tienen plazos increíblemente estrictos y requisitos de prueba de pérdida. Un solo error puede resultar en una denegación total. Manejamos el complejo papeleo, nos aseguramos de que todos los daños estén categorizados adecuadamente y luchamos por cada dólar permitido bajo las estrictas pautas federales.',
        caseTitle: 'Ejemplo de Caso: Inundación por Marejada Ciclónica',
        caseBefore:
          'Oferta del Seguro: $45,000 (Costos de secado estructural y reparación subvaluados)',
        caseAfter:
          'Recuperación de Elite: $142,000 (Presentó estimaciones detalladas de Xactimate que prueban el verdadero costo de remediación y reparación bajo las pautas del NFIP)',
        ctaTitle: '¿Propiedad Inundada?',
        ctaDesc:
          'Los reclamos por inundación tienen estrictos plazos federales. No se demore—contáctenos para manejar el complejo proceso del NFIP.',
      },
    },
    privacy: {
      badge: 'Legal',
      title: 'Política de Privacidad',
      lastUpdated: 'Última actualización: Enero 2025',
      intro:
        'Elite Property Adjusters LLC ("nosotros" o "nuestro") se compromete a proteger su privacidad. Esta Política de Privacidad explica cómo recopilamos, usamos, divulgamos y protegemos su información cuando visita nuestro sitio web o utiliza nuestros servicios.',
      contactTitle: 'Contáctenos Sobre Privacidad',
      contactText:
        'Si tiene preguntas o inquietudes sobre esta Política de Privacidad o nuestras prácticas de datos, contáctenos:',
      sections: [
        {
          heading: 'Información que Recopilamos',
          content:
            'Podemos recopilar información personal que usted nos proporciona voluntariamente cuando completa nuestro formulario de contacto, solicita una consulta o se comunica con nosotros. Esto incluye su nombre, dirección de correo electrónico, número de teléfono, dirección de la propiedad y detalles sobre su reclamo de seguro o daños a la propiedad.',
        },
        {
          heading: 'Cómo Usamos su Información',
          content:
            'Usamos la información que recopilamos para responder a sus consultas, proporcionar nuestros servicios de ajuste público, comunicarnos con usted sobre su reclamo, enviarle actualizaciones relevantes, mejorar nuestro sitio web y servicios, y cumplir con obligaciones legales.',
        },
        {
          heading: 'Compartir Información',
          content:
            'No vendemos, intercambiamos ni alquilamos su información personal a terceros. Podemos compartir su información con compañías de seguros como parte del proceso de reclamos (con su autorización), proveedores de servicios de confianza que asisten en nuestras operaciones, y según lo requiera la ley o para proteger nuestros derechos legales.',
        },
        {
          heading: 'Seguridad de Datos',
          content:
            'Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger su información personal contra acceso no autorizado, alteración, divulgación o destrucción. Sin embargo, ningún método de transmisión por Internet es 100% seguro.',
        },
        {
          heading: 'Cookies y Seguimiento',
          content:
            'Nuestro sitio web puede usar cookies y tecnologías de seguimiento similares para mejorar su experiencia de navegación, analizar el tráfico del sitio y comprender de dónde provienen nuestros visitantes. Puede controlar la configuración de cookies a través de las preferencias de su navegador.',
        },
        {
          heading: 'Enlaces de Terceros',
          content:
            'Nuestro sitio web puede contener enlaces a sitios web de terceros. No somos responsables de las prácticas de privacidad o el contenido de estos sitios externos. Le recomendamos revisar las políticas de privacidad de cualquier sitio de terceros que visite.',
        },
        {
          heading: 'Sus Derechos',
          content:
            'Usted tiene derecho a acceder, corregir o eliminar su información personal. También puede optar por no recibir comunicaciones de marketing de nuestra parte en cualquier momento contactándonos directamente o usando la opción de cancelar suscripción en nuestros correos electrónicos.',
        },
        {
          heading: 'Privacidad de Menores',
          content:
            'Nuestros servicios no están dirigidos a personas menores de 18 años. No recopilamos intencionalmente información personal de niños.',
        },
        {
          heading: 'Cambios a Esta Política',
          content:
            'Podemos actualizar esta Política de Privacidad de vez en cuando. Cualquier cambio se publicará en esta página con una fecha de revisión actualizada. Le recomendamos revisar esta política periódicamente.',
        },
      ],
    },
    terms: {
      badge: 'Legal',
      title: 'Términos de Servicio',
      lastUpdated: 'Última actualización: Enero 2025',
      intro:
        'Bienvenido al sitio web de Elite Property Adjusters LLC. Al acceder o utilizar nuestro sitio web y servicios, usted acepta estar sujeto a estos Términos de Servicio. Léalos cuidadosamente antes de usar nuestro sitio.',
      contactTitle: 'Contáctenos',
      contactText:
        'Si tiene alguna pregunta sobre estos Términos de Servicio, contáctenos:',
      sections: [
        {
          heading: 'Aceptación de Términos',
          content:
            'Al acceder y usar este sitio web, usted acepta y acuerda estar sujeto a estos Términos de Servicio y nuestra Política de Privacidad. Si no está de acuerdo con estos términos, por favor no use nuestro sitio web o servicios.',
        },
        {
          heading: 'Descripción de Servicios',
          content:
            'Elite Property Adjusters LLC es una firma de ajustadores públicos licenciada que asiste a propietarios con reclamos de seguros. Nuestros servicios incluyen inspecciones de propiedad, documentación de daños, presentación de reclamos y negociación con compañías de seguros en nombre de nuestros clientes.',
        },
        {
          heading: 'Sin Garantía de Resultados',
          content:
            'Si bien nos esforzamos por maximizar el acuerdo de reclamo de seguro de cada cliente, no podemos ni garantizamos resultados específicos. Cada reclamo es único y los resultados dependen de muchos factores, incluidos los términos de la póliza, la magnitud del daño y las decisiones de la compañía de seguros.',
        },
        {
          heading: 'Relación Profesional',
          content:
            'El uso de este sitio web no crea una relación profesional o contractual entre usted y Elite Property Adjusters LLC. Un compromiso formal comienza solo al firmar un acuerdo escrito con nuestra firma.',
        },
        {
          heading: 'Contenido del Sitio Web',
          content:
            'La información proporcionada en este sitio web es solo para fines informativos generales y no constituye asesoramiento legal, financiero o profesional. Si bien nos esforzamos por mantener la información precisa y actualizada, no garantizamos la integridad o exactitud del contenido.',
        },
        {
          heading: 'Propiedad Intelectual',
          content:
            'Todo el contenido de este sitio web, incluidos textos, gráficos, logotipos, imágenes y software, es propiedad de Elite Property Adjusters LLC y está protegido por las leyes de propiedad intelectual aplicables. No puede reproducir, distribuir o crear obras derivadas sin nuestro permiso por escrito.',
        },
        {
          heading: 'Conducta del Usuario',
          content:
            'Usted acepta no usar nuestro sitio web para ningún propósito ilegal, intentar obtener acceso no autorizado a nuestros sistemas, transmitir cualquier código dañino o malware, o interferir con el funcionamiento adecuado del sitio web.',
        },
        {
          heading: 'Limitación de Responsabilidad',
          content:
            'Elite Property Adjusters LLC no será responsable de ningún daño indirecto, incidental, especial o consecuente que surja de su uso de este sitio web o nuestros servicios. Nuestra responsabilidad total no excederá los honorarios pagados por nuestros servicios.',
        },
        {
          heading: 'Ley Aplicable',
          content:
            'Estos Términos de Servicio se rigen e interpretan de acuerdo con las leyes del Estado de Florida. Cualquier disputa que surja de estos términos se resolverá en los tribunales del Condado de Miami-Dade, Florida.',
        },
        {
          heading: 'Cambios a los Términos',
          content:
            'Nos reservamos el derecho de modificar estos Términos de Servicio en cualquier momento. Los cambios serán efectivos inmediatamente después de su publicación en este sitio web. Su uso continuado del sitio web después de los cambios constituye la aceptación de los términos actualizados.',
        },
      ],
    },
  },
}
